import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/es5/util/colors';
import 'vuetify/src/stylus/app.styl';

const mainColor = "lightGreen";

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: {
      base: colors[mainColor].base
    },
    secondary: {
      base: colors[mainColor].darken1
    },
    accent: {
      base: colors[mainColor].lighten5
    }
  },
  options: {
    customProperties: true
  }
}) 
